<script>
export default {
	props: {
		title: {
			type: String,
			required: true
		},

		showClose: {
			type: Boolean,
			default() {
				return false
			}
		}
	},
	data() {
		return {
			show: false,
			time: null,
			callback: null
		}
	},
	methods: {
		open(time = null, callback = null) {
			this.show = true
			if(time) {
				this.$set(this, 'time', time)  
				setTimeout(this.close, this.time)
			} 

			this.$set(this, 'callback', callback)
		},

		close() {
			this.show = false
			this.$set(this, 'time', null)  
			this.$emit('closed')
			if(this.callback) {
				this.callback()
				this.$set(this, 'callback', null)
			}
		
		}
	}
}
</script>
<template>
	<div v-if="show" class="pf-modal">
		<div class="pf-modal__wrapper m-auto">
			<div class="pf-modal__header d-flex justify-content-between">
				<span>
				{{ title }}
				</span>
				<button v-if="showClose" @click="close" class="pf-modal__close">X</button>
			</div>
			<div class="pf-modal__body">
				<slot/>
			</div>
		</div>
	</div>
</template>